import createRecurrenceRange from './createRecurrenceRange';
import DayOfWeekIndexType from 'owa-service/lib/contract/DayOfWeekIndexType';
import getWeekOrder from './getWeekOrder';
import recurrenceType from 'owa-service/lib/factory/recurrenceType';
import RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import relativeMonthlyRecurrence from 'owa-service/lib/factory/relativeMonthlyRecurrence';
import RelativeMonthlyRecurrence from 'owa-service/lib/contract/RelativeMonthlyRecurrence';
import { DAYS_OF_WEEK } from './constants';
import { getDay, DisplayDate } from 'owa-datetime';

export default function createRelativeMonthlyRecurrence(
    startDate: DisplayDate,
    interval: number,
    endDate: DisplayDate,
    dayOfWeekIndex?: DayOfWeekIndexType
): RecurrenceType {
    const dayOfWeek = DAYS_OF_WEEK[getDay(startDate)];

    const recurrencePattern = createRelativeMonthlyRecurrencePattern(
        dayOfWeek,
        dayOfWeekIndex || getWeekOrder(startDate),
        interval
    );

    const recurrenceRange = createRecurrenceRange(startDate, endDate);

    return recurrenceType({
        RecurrencePattern: recurrencePattern,
        RecurrenceRange: recurrenceRange,
    });
}

function createRelativeMonthlyRecurrencePattern(
    daysOfWeek: string,
    dayOfWeekIndex: DayOfWeekIndexType,
    interval: number
): RelativeMonthlyRecurrence {
    return relativeMonthlyRecurrence({
        DaysOfWeek: daysOfWeek,
        DayOfWeekIndex: dayOfWeekIndex,
        Interval: interval,
    });
}
